import React, { useState } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'
import classNames from 'classnames'

import Loading from './../Loading'
import ConvertibleText from '../ConvertibleText'
import IncludedCheckbox from '../IncludedCoverages'

const Accordion = (WrappedComponent, arrayList, optionalComponent = accordionSuggestionPanel) => {
  const AccordionHOC = (props) => {
    const {
      isModified,
      name,
      manuallySetPricing,
      options,
      onBlurTextboxHandler,
      submission
    } = props

    const [activeKey, setActiveKey] = useState('')

    const handleSelect = (key) => setActiveKey(key)

    const isSpecialCoverage = (val) => [
      'terror', 'identityRecovery', 'hnoaPremium', 'pollution',
      'subsidence', 'extendedCompletedOps', 'bankPremium', 'additionalInsureds'
    ].includes(val)

    return (
      <PanelGroup
        accordion
        id="accordion-group"
        activeKey={activeKey}
        onSelect={handleSelect}
      >
        {arrayList.map((item, index) => {
          const option = options[index]
          const hideClass = option.hideElement || ''

          const isOIWithManualPricing = manuallySetPricing && isSpecialCoverage(option.value) && submission?.type === 'oi'

          const showPriceValues = option.value !== 'isPCOpsExcluded' && option.value !== 'isESWorkExcluded'

          const canToggle = option.value !== 'isESWorkExcluded'

          const showIncludedCheckbox = manuallySetPricing &&
            name !== 'baseCoverage' &&
            (option.value === 'hnoaPremium' || option.value === 'pollution' || index > 2)

          return (
            <Panel eventKey={index} key={index} className={hideClass}>
              <Panel.Heading>
                <div className="coverage-container">
                  <div className="row">
                    <div className={isOIWithManualPricing ? 'col-sm-6 col-xs-12' : 'col-sm-7 col-xs-12'}>
                      <WrappedComponent {...props} options={[option]} />
                    </div>
                    {isModified ? (
                      <div className="col-sm-offset-3 col-sm-1 col-xs-10">
                        <Loading width="23px" height="23px" />
                      </div>
                    ) : showPriceValues ? (
                      <div className="price-values text-right col-sm-4 col-xs-10">
                        <ConvertibleText
                          manuallySetPricing={manuallySetPricing}
                          disabled={!option.selected || option.disable}
                          value={{ name: option.key, text: option.text }}
                          onBlurHandler={onBlurTextboxHandler}
                        />
                      </div>
                    ) : (
                      <div className="price-values text-right col-sm-4 col-xs-10" />
                    )}
                    <div className="col-sm-1 col-xs-2">
                      {canToggle && <Panel.Title toggle />}
                    </div>
                    {showIncludedCheckbox ? (
                      <div className="col-sm-1">
                        <IncludedCheckbox {...props} options={[option]} />
                      </div>
                    ) : <div />}
                  </div>
                </div>
              </Panel.Heading>

              <Panel.Body collapsible>
                {optionalComponent(arrayList[index])}
              </Panel.Body>

              {option.additionalCoverageOptionalForm !== undefined && (
                <Panel.Body>
                  {option.additionalCoverageOptionalForm}
                </Panel.Body>
              )}
            </Panel>
          )
        })}
      </PanelGroup>
    )
  }

  return AccordionHOC
}

const accordionSuggestionPanel = ({
  head,
  subHeader,
  body,
  body_2,
  footer,
  isPCOpsExcluded,
  isESWorkExcluded
}) => {
  const mbStyle = isPCOpsExcluded && isESWorkExcluded ? { marginBottom: '5px' } : {}

  return (
    <div className="suggestion-box text-left">
      {head && (
        <div className="mb" style={mbStyle}>
          <strong>{head}</strong>:
          <span className="text-success ml">{subHeader}</span>
        </div>
      )}

      <div className={classNames({ 'PCopsSuggestion': isPCOpsExcluded })}>
        {body}
      </div>

      {body_2 && (
        <div>
          <br />
          {body_2}
        </div>
      )}

      <i>{footer}</i>
    </div>
  )
}

export default Accordion
